/** Max ECMAScript Date in ms. The reverse value never exceeds 16 digits, so
 *  padding to 19 guarantees fixed-width lexical sort with headroom. */
export const MAX_MS = 8640000000000000;

/**
 * Descending-time-sortable RowKey: `<reverse>_<eventId>`, where reverse =
 * MAX_MS - eventEpochMs (newest-first within a partition). Derived from the
 * EVENT's own timestamp (not emit time) so a redelivery of the same event
 * yields the same RowKey → an upsert is a harmless overwrite (idempotent).
 */
export function makeRowKey(timestampIso: string, eventId: string): string {
  const parsed = Date.parse(timestampIso);
  const epoch = Number.isFinite(parsed) ? parsed : Date.now();
  const reverse = MAX_MS - epoch;
  return `${String(reverse).padStart(19, "0")}_${eventId}`;
}
